import React, { useState, useEffect } from 'react';

import { dataGridPremiumColumns } from '../../utils/helper';
import { DataGridIdentifiers, DatagridPremiumUi } from '../Interface';
import vatDeterminationService from '../../service/vatDetermination.service';
import { DocumentDirectionField, DocumentDirection } from '../../config/DocumentDirection';
import { BpTypeList } from '../../config/company';
import { AreaTypeList } from '../../config/companyGroup';
import { SubjectOption } from '../../config/vatCodes';
export const VatDeterminationReports = ({
  refetch,
  values,
  viewField,
  operatorsDisabled,
  rowSelection,
  autoCompleteOptions,
}) => {
  const { refetchTable, setRefetchTable } = refetch;
  const { setSelectedValues } = values;
  const { rowSelectionModel, setRowSelectionModel } = rowSelection;

  const dDirectionOptions = DocumentDirectionField.filter((option) => option.value !== DocumentDirection.INTERNAL);

  const [reports, setReports] = useState({ rows: [], rowCount: 0 });

  const initialState = {
    filter: { filterModel: { items: [], logicOperator: 'and' } },
    sorting: {
      sortModel: [{ field: 'id', sort: 'asc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    },
    density: 'compact',
  };

  useEffect(() => {
    if (operatorsDisabled) {
      setRowSelectionModel([]);
    }
  }, [operatorsDisabled]);

  const getList = (gridState) => {
    vatDeterminationService.getItems(gridState).then((data) => {
      setReports(data);
    });
  };

  const columns = dataGridPremiumColumns([
    {
      field: 'id',
      headerName: '#',
      type: 'string',
    },
    {
      field: 'vatCode',
      headerName: 'Áfakulcs',
      type: 'singleSelect',
      valueOptions: autoCompleteOptions?.vatCode,
    },
    {
      field: 'documentDirection',
      headerName: 'Irány',
      type: 'singleSelect',
      valueOptions: dDirectionOptions,
    },
    {
      field: 'bpType',
      headerName: 'ÜP típus',
      type: 'singleSelect',
      valueOptions: BpTypeList,
    },
    {
      field: 'area',
      headerName: 'Teljesítés országa',
      type: 'singleSelect',
      valueOptions: AreaTypeList,
    },
    {
      field: 'vatCodeSubject',
      headerName: 'Tárgya',
      type: 'singleSelect',
      valueOptions: SubjectOption,
    },
  ]);

  return (
    <DatagridPremiumUi
      datagridIdentifier={DataGridIdentifiers.VatDetermination}
      datagridInitialState={initialState}
      dataLoader={getList}
      rows={reports.rows}
      refetch={{ refetchTable, setRefetchTable }}
      rowCount={reports.rowCount}
      columns={[...columns]}
      onRowClick={(rowData) => {
        if (!viewField) return;
        setSelectedValues(rowData.row);
      }}
      paginationAndfilterMode="server"
      onRowSelectionModelChange={(newRowSelectionModel) => {
        setRowSelectionModel(newRowSelectionModel);
      }}
      rowSelectionModel={rowSelectionModel}
      disableRowSelectionOnClick={!viewField}
    />
  );
};
